export default __webpack_public_path__ + "static/media/GAMA-500-STAR.73286d91.pdf";